import React from 'react';
import { Outlet } from 'react-router';
import { AuthGuard } from './AuthGuard';

/**
 * A wrapper component that protects all child routes with authentication
 */
export const ProtectedRoute: React.FC = () => {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
};
